import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';
import Members from './members';

const enhance = compose(
  withNamespaces(['chat', 'common']),
);
export default enhance(Members);
